module.exports = __webpack_public_path__ + "static/media/card5_5.cc5861d9.png";